import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
`;

export const ButtonWrapper = styled.div`
  margin: 0 10px 0 0;
`;
